import { BuyerTypeCountryFields } from "@/modules/billing/buyer/BuyerTypeCountryFields";
import { UnsupportedCountryNotice } from "@/modules/billing/buyer/UnsupportedCountryNotice";
import Box from "@mui/material/Box";
import { observer } from "mobx-react";
import { CreditAmountButtons } from "./CreditAmountButtons";
import { CreditAmountPickerState } from "./CreditAmountPickerState";
import { CreditValueDetails } from "./CreditValueDetails";

// Amount picker with the value breakdown below it. Picking a buyer type and
// country turns the VAT disclaimer into an exact price. The state lives in the
// page so the call to action can carry the selection over to the topup form.
export const CreditValuePickerWithDetails = observer(
  ({ state }: { state: CreditAmountPickerState }) => (
    <Box>
      <Box sx={{ maxWidth: 400 }}>
        <BuyerTypeCountryFields
          buyerType={state.buyerType}
          countryCode={state.countryCode}
          onChange={(selection) => state.setBuyerSelection(selection)}
        />
        {!state.isCountrySupported && (
          <UnsupportedCountryNotice
            buyerType={state.buyerType}
            countryCode={state.countryCode}
          />
        )}
      </Box>

      <CreditAmountButtons
        selectedAmount={state.selectedAmount}
        onSelectAmount={(amount) => state.setSelectedAmount(amount)}
      />
      <Box sx={{ mt: 3 }}>
        <CreditValueDetails
          credits={state.selectedAmount}
          vatInfo={state.vatInfo}
        />
      </Box>
    </Box>
  ),
);
